import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import cn from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import TextCropper from '@omilia/text-cropper';

import Time from 'components/Time';
import { projectType } from 'types';

import { ListItem } from '../../../components/List';
import ProjectAvatar from './components/ProjectAvatar';
import './style.scss';

/* eslint-disable camelcase */
export const getUser = ({ created_by, updated_by }) => {
  if (!_isEmpty(updated_by)) {
    return updated_by;
  }

  if (!_isEmpty(created_by)) {
    return created_by;
  }

  return null;
};

export default class ProjectItem extends Component {
  static propTypes = {
    isGrid: PropTypes.bool.isRequired,
    project: projectType.isRequired,
    selectProject: PropTypes.func.isRequired,
  };

  handleClick = () => this.props.selectProject(this.props.project);

  // TODO: Fix jsx-a11y issues
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  render() {
    const { project, isGrid } = this.props;
    const user = getUser(project);

    return (
      <ListItem
        styleName={cn('item', {
          'is-grid': isGrid,
        })}
        onClick={this.handleClick}
      >
        <div styleName="inner">
          <div styleName="part is-first">
            <TextCropper styleName="title" text={project.name} />
            <span styleName="account">{project.account}</span>
          </div>
          {!isGrid && (
            <div styleName="part is-middle">
              <span styleName="count">{project.entity_count}</span>{' '}
              {pluralize('Entity', project.entity_count)}
            </div>
          )}
          {isGrid ? (
            <div data-test="grid" styleName="part is-last">
              <div styleName="is-left">
                <ProjectAvatar styleName="avatar" user={user} />
                <span styleName="time">
                  Updated <Time timestamp={project.updated_at} />
                </span>
              </div>
              <div styleName="is-right">
                <span styleName="count">{project.entity_count}</span>{' '}
                {pluralize('Entity', project.entity_count)}
              </div>
            </div>
          ) : (
            <div styleName="part is-last">
              <ProjectAvatar styleName="avatar" user={user} />
              <span styleName="time">
                Updated <Time timestamp={project.updated_at} />
              </span>
            </div>
          )}
        </div>
      </ListItem>
    );
  }
}
